export default {
  hello: 'Olá Mundo!',
  messageInfo: {
    // 短信内容替换
    RedeemReward: ` Troca realizada com sucesso! 🎉
🏆 Valor do prêmio: R$ amountReplace 🏆
O prêmio já foi creditado e você pode verificar e sacar na página 'Minha Conta'.
Obrigado por participar, mais surpresas esperam por você!`,
    DepositReward: `Receba o bônus de depósito R$ amountReplace`,
    AgentRebate: `Receba o bônus de agente de R$ amountReplace`,
    AgentCommission: `Retirar comissäo R$ amountReplace com sucesso`,
    PddReward: `Receba o bônus Magnata de R$ amountReplace`,
    RedEnvelopeRainReward: `Receba o bônus da sorte de R$ amountReplace`,
    LevelReward: `Receba a recompensa de nível R$ amountReplace `,
    VipReward: `Receba recompensa vip R$ amountReplace`,
    DepositBonus: `Receba o bônus extra de depósito R$ amountReplace`,
    PwaReward: `Receba o bônus PWA de R$ amountReplace`,
    RetainReward: `Receba o Bônus diário de depósito R$ amountReplace`,
    TreasureBoxReward: `Receba recompensas de baú de tesouro R$ amountReplace`,
    BlindBoxReward: `Tornando-se o jogador sortudo de hoje. Clique na blind box abaixo para receber um bônus, Recompensa máxima R$ amountReplace`,
    AidReward: `Receba o bônus de auxílio de  R$ amountReplace`,
    AidWeekReward: `Receba o bônus semanal de auxílio de R$ amountReplace`,
    UserRebateReward: `Resgatar R$ amountReplace de Recompensa de Rebate de Apostas`,
    CustomActivityReward: `Aprovado na análise e recompensa da atividade de R$ amountReplace foi concedida.`,
    GuaGuaLeReward: `Resgatar recompensa da raspadinha de R$ amountReplace.`,
    SuperWheelReward: `Reivindique R$ amountReplace de recompensa em dinheiro da roleta.`,
    SuperWheelDepositRatio: `Reivindique R$ amountReplace de recompensa de {{ratio}}% no depósito da roleta.`,
    SuperWheelDepositCash: `Reivindique R$ amountReplace de recompensa em dinheiro pelo convite de amigos na roleta.`,
    InviteeReward: `Reivindique R$ amountReplace de recompensa por ajudar um amigo a girar a roleta.`,
    Deposit: `Depósito R$ amountReplace  sucesso`,
    WithdrawalFrozen: `Submeta a saque R$ amountReplace aplicacäo com sucesso`,
    Withdrawal: `Saque R$ amountReplace com sucesso`,
    WithdrawalRelease: `A retirada falhou. R$ amountReplace foram devolvidos à conta,Retire o dinheiro novamente ou entre em contatocom o atendimento ao cliente.`,
    CashRecharge: `Depósito R$ amountReplace  sucesso`,
    BonusRecharge: `Concedeu do sistema R$ amountReplace `,
    BonusDebit: `Débito do sistema R$ amountReplace`,
    ActivationReward: `Receba o bônus de ativação R$ amountReplace`,
    MysteryBonusReward: `Receba o bônus misterioso R$ amountReplace`,
  },
  barItem: {
    servico: 'Serviço',
    meu: 'Meu',
    home: 'Inicio',
    promocao: 'Promoção',
    saque: 'Saque',
  },
  ErrorBoundary: {
    Error: 'Erro',
    SomethingWentWrong:
      'Algo deu errado, por favor, tente novamente mais tarde',
    Retry: 'Tentar novamente',
  },
  Installation: {
    SuccessfulDetection: 'Detecção bem-sucedida',
    DetectEnd: 'Detecção concluída',
    InstallNow: 'Instalar agora',
    DetectionFailed: 'Falha na detecção do ambiente de instalação',
    InstallationSuccess: 'Instalação bem-sucedida, iniciando',
    tryToLaunch: 'Já instalou o PWA, deseja iniciar agora?',
    launch: 'Iniciando',
    install: 'Instalar',
  },
  Tip: {
    CongratulationsWinning: 'Parabéns por ganhar',
    ScratchCards: `Raspadinhas`,
    BonusChips: 'fichas de bônus',
  },
  LoginOrReg: {
    AccountTips: `Conta / Número de telefone`,
    AccountErrorTips: `Por favor, insira um número de telefone com 11 dígitos.`,
    confirmPasswordTips: `Confirme a senha inserida`,
    confirmPasswordErrorTips: `As senhas são diferentes`,
    PasswordTips: `Por favor, insira a senha`,
    PasswordErrorTips: `Defina uma senha de 8 a 20 dígitos.`,
    PhoneTips: `Número de telefone`,
    PhoneErrorTips: `Por favor, insira um número de telefone com 11 dígitos.`,
    PhoneNumberDescription: `O número do celular será usado para verificar se seudinheiro está
          seguro quando você tentar sacar.`,
    PhoneCodeTips: `Insira o código de verificação de 4 dígitos.`,
    PhoneCodeErrorTips: `Insira o código de verificação de 4 dígitos.`,
    Login: `Entrar`,
    Reg: `Registro`,
    Code: `Código`,
    MobilePhoneNumber: `O número do celular será usado para verificar se seudinheiro está seguro
        quando você tentar sacar.`,
    checkPasswordTitle: `A senha é muito simples`,
    checkPasswordContent: `Senhas assim são fáceis de adivinhar! Recomendamos o uso de uma combinação mais complexa.`,
    checkPasswordConfirm: `Continuar`,
    checkPasswordCancel: `Alterar senha`,
    pleaseLoginFirst: `Por favor, faça login primeiro`,
  },
  home: {
    install: `Instalar`,
    TopHeader: {
      Id: `ID:`,
      SA: `Saldo`,
    },
    SideBar: {
      Saque: `Saque`,
      CasaDeJogos: `Casa de Jogos`,
      Promocoes: `Promoções`,
      MeusRelatorios: `Meus relatórios`,
      Configuracao: `Configuração`,
      CentroDeAgentes: `Centro de Agentes`,
      CanalOficial: `Canal Oficial`,
      Lingua: `Língua`,
      Direitos: `Todos os direitos reservados. 18+`,
      LoginOrRegTips: `Por favor, registrar/faça login primeiro`,
      LoginRestrictions: `Você precisa de uma conta de login para jogar.`,
      Portuguese: `Português`,
      English: `Inglês`,
    },
    Footer: {
      Partners: `Parceiros`,
      OfficialChannel: `Canal Oficial`,
      DireitosReservados: `©2025 {siteName}.Todos os direitos reservados. 18+`,
      Ver: `ver:1.1.5(1A)`,
    },
    PhoneVerify: {
      SecurityCenter: `Central de segurança`,
      MobilePhoneBindingReminder: `Caro usuário, para a segurança da sua conta, por favor, vá até o centro
        pessoal e vincule seu número de celular.`,
      ConfirmText: `Verificar agora`,
      CancelText: `Verificar mais tarde`,
    },
    GuideInstallWithServico: {
      NewVersionTitle: 'Novidades da Versão 2.0',
      MoreGamesAdded: 'Mais jogos adicionados',
      BenefitsDistributed: 'Bônus e benefícios ampliados',
      OptimizedForspeed: 'Interface e velocidade otimizadas',
      AdditionalGain: 'Você ainda pode ganhar um bônus extra de',
      MoreBonusesDistributed: 'Bônus e benefícios ampliados',
      SystemInterfaceOptimized: 'Interface e velocidade otimizadas',
      UpdateNow: 'Atualizar agora',
      AfterInstallTip:
        'Após instalar o app, volte para a tela inicial e abra-o para usar',
      AndroidInstallTitle: 'Instalação de um aplicativo Android:',
      AndroidInstallSteps:
        '1. Clique no botão acima para baixar o arquivo de instalação para Android.\n2. Permita a instalação de aplicativos de fontes desconhecidas nas configuraçóes do seu dispositivo.\n3. Conclua a instalacao.',
      SecurityCertification:
        'Este aplicativo passou pela certificacao de seguranca do GooglePlay, sinta-se a vontade para reallzar a instalação.',
      ContactSupport: 'Entrar em contato com o suporte',
      SelectChannel: 'Selecionar canal',
    },
  },
  Promocao: {
    Deposit: 'Bônus',
    Aid: 'Auxílio',
    Wheel: 'Mistério',
    TreasureBox: 'Baú',
    Rebate: 'Reembolso',
    RedEnvelopeRain: 'Sorte',
    All: 'Tudo',
  },
  meu: {
    Service: `Serviço`,
    Deposit: `Depósito`,
    Sake: `Saque`,
    CPF: `CPF`,
    Balance: `Saldo`,
    ActivityBonus: `Bônus da Atividade`,
    AgentBonus: `Bônus do Agente`,
    Logout: `Sair`,
    Saque: {
      Title: `Configurar senha de saque`,
      Content: `Para a segurança dos seus fundos, por favor, configure primeiro uma senha de fundo`,
      confirmText: `Configurar agora`,
      cancelText: `Não configurar agora`,
    },
    Tabs: {
      AgentCenter: `Centro de Agentes`,
      MyReports: `Meus relatórios`,
      Settings: `Configuração`,
      Message: `Mensagem`,
    },
    quit: {
      Title: `Sair da conta atual`,
      QuitTips: `Por favor, lembre-se de sua conta de login e senha para fazer login novamente.`,
      Senna: `saindo...`,
    },
    CPFInterface: {
      Title: 'Informações do CPF',
      PersonalInfo: 'Informações Pessoais',
      Name: 'Nome',
      CPF: 'CPF',
      PixAccount: 'Conta PIX',
      CPFId: 'CPF ID',
      Mobile: 'Telefone',
      Email: 'Email',
      CNPJ: 'CNPJ',
      EVP: 'EVP',
    },
  },
  MiddlePage: {
    Recomendados: 'Recomendados',
    Play: 'JOGUE',
  },
  Deposit: {
    noChannelSaque: `Nenhum canal de saque configurado para hoje.`,
    noChannel: `Nenhum canal de pagamento configurado para hoje.`,
    Paymentchannel: `Canal de pagamento：`,
    valor: `valor`,
    ParticipateInpromotions: `Participe de promoções`,
    Participate: 'Bônus extra gratuito R$ ',
    ReceiveAreward: `Receba uma recompensa de R$`,
    NoDiscountCodeQuantity: `Bônus resgatável após { turnoverTimes }x faturamento`,
    DepositReceives: `Ganhe  { rewardRatios }% de bônus extra em dinheiro grátis no seu depósito!`,
    MaximumBonusAmount: `Valor máximo do bônus: R$ { maxAmount }.`,
    BonusCanBeWthdrawn: `Bônus pode ser sacado após { rollingRatio}x o faturamento.`,
    TimesADay: `vezes: { perDayRewardTimes } vezes por dia`,
    NoLimitOfTimes: `vezes: Sem limite de vezes`,
    UserTypeOptions: {
      All: `condições：Todos os usuários`,
      FirstDeposit: `condições：Primeiro depósito`,
      CurrentDeposit: `Hoje Depósito >=`,
      CurrentBet: `Hoje Apostas >=`,
      AccumulateDeposit: `Depósito acumulado >=`,
      AccumulateBet: `Aposta acumulada >=`,
    },
    popPage: {
      Title: `Informações do Pagador`,
      RuleTips: `De acordo com as regulamentações bancárias do Brasil, se as informações da conta bancária para pagamento não coincidirem com o nome e o CPF inseridos, o pagamento não será realizado com sucesso`,
      YourName: `Seu Nome`,
      EnterYourName: `insira seu nome`,
      YourCPF: `Seu CPF`,
      EnterYourCPF: `insira seu CPF`,
      uuPaySchema: {
        payeeName: `O nome não pode estar vazio`,
        payeeCpf: `Por favor, insira um CPF com 11 dígitos.`,
      },
    },
  },
  DepositoQRcode: {
    ScanningTutorial: `Abra seu aplicativo de pagamento, escaneie ou copie e cole o código QR abaixo para concluir o pagamento.`,
    QRCodeTimesDescription: `Este código QR só pode ser usado para pagamento uma vez. Se precisar efetuar outro pagamento, por favor, volte e tente novamente.`,
    ExpirationReminder: `O código QR está expirado.`,
    CopyQRcode: `Copiar o código QR`,
    QRcodeAddress: `Endereço do código QR... **`,
    CreationDate: `Data de Criação`,
    PaymentOrderNumber: `Número da ordem de pagamento`,
    MerchantOrderNumber: `Número do pedido do comerciante`,
  },
  DepositoResults: {
    OrderNumber: 'Número do pedido',
    OrderQuery: 'Consulta de pedido',
    WaitingForResults: 'aguardando resultados da consulta de pedido.',
    NoResults: 'Sem resultados',
    TryAgainMessage: 'Por favor, clique no botão para tentar novamente.',
    RetryQuery: 'Refaça a consulta',
    DepositSuccessful: 'Depósito bem-sucedido',
    DepositFailed: 'Depósito falhou',
    ReturnToHome: 'Voltar para a página inicial',
    ReturnToHomeMessage:
      'Clique no botão no canto superior esquerdo para voltar',
    Amount: 'R$',
  },
  Registro: {
    LeftText: `Meus relatórios`,
    AccountRegistration: `Registro de Conta`,
    BettingRecords: `Recordes de Apostas`,
    options: {
      TodayData: `Dados de Hoje`,
    },
    Filter: `Filtro`,
    All: `Todos`,
    Bet: `Apostar`,
    WinOrLose: `Ganhar ou perder`,
    NoMoreData: `Não há mais dados`,
    NoRecordsYet: `Nenhum registro ainda`,
    NoAccountRecords: ` você não tem registros de movimentação de conta no momento`,
    NoBettingRecords: ` por favor, entre em contato com o agente para recarregar as moedas e começar o jogo`,
    FilterConditions: `Condições de Filtro`,
    SelectTime: `Selecionar Tempo`,
    SelectType: `Selecionar Tipo`,
    Turnover: `Faturamento`,
    Times: `Vezes`,
    constants: {
      flowTypes: {
        Deposit: 'Depósito de Pedido',
        Withdrawal: 'Saque do Pedido',
        WithdrawalFrozen: 'Saque do Pedido',
        WithdrawalRelease: 'Quantia Descongelada no Saque',
        CashRecharge: 'Recarga em Dinheiro',
        BonusRecharge: 'Adição de Bônus',
        BonusDebit: 'Dedução de Bônus',
        AgentCommission: 'Comissão de Agente',
        AgentRebate: 'Reembolso de Agente',
        DepositReward: 'Recompensa de Promoção de Depósito',
        DepositBonus: 'Recompensa de Bônus de Depósito',
        RedeemReward: 'Código de Resgate',
        PddReward: 'Recompensa PDD',
        PwaReward: 'Recompensa PWA',
        ActivationReward: 'Recompensa de Ativação',
        RedEnvelopeRainReward: 'Recompensa de Chuva de Envelope Vermelho',
        RetainReward: 'Recompensa de Retenção',
        VipReward: 'Recompensa VIP',
        LevelReward: 'Recompensa de Nível',
        AidReward: 'Fundo de Auxílio',
        SuperWheelReward: 'Recompensa da Roleta Super',
        UserRebateReward: 'Recompensa de Cashback',
        InviteeReward: 'Recompensa para Convidados',
        TreasureBoxReward: 'Recompensa do Baú do Tesouro',
        MysteryBonusReward: 'Recompensa de Bônus Misterioso',
        Bet: 'Apostas',
        Settle: 'Liquidação',
        BetSettle: 'Apostas e Liquidação',
        BetCancel: 'Aposta Cancelada',
        BetAdjust: 'Aposta Modificada',
        BetCredit: 'Transferência de Entrada',
        BetDebit: 'Transferência de Saída',
      },
      options: {
        TodayData: 'Dados de Hoje',
        YesterdayData: 'Dados de Ontem',
        Last7DaysData: 'Dados das últimas 7 dias',
        Last15DaysData: 'Dados das últimas 15 dias',
        Last30DaysData: 'Dados das últimas 30 dias',
      },
      types: {
        All: 'Tudo',
        Deposit: 'Depósito',
        Withdrawal: 'Saque',
        System: 'Sistema',
        Reward: 'Bônus',
        Game: 'Aposta',
      },
    },
    WalletFlowDetail: {
      Type: `Tipo`,
      Number: `Número`,
      Transaction: `Transação`,
    },
    GameDetail: {
      Total: `Total`,
      BetTimes: `Apostar {totalBetTimes} vezes`,
      WinOrLose: `Ganhar ou perder`,
      idMessage: `Nº Transac.`,
    },
  },
  Profile: {
    leftText: `Configuração`,
    BasicSettings: `Configurações Básicas`,
    Profile: `Perfil:`,
    Surname: `Apelido:`,
    RegisteredAccount: `Conta registrada:`,
    Id: `Id:`,
    SecuritySettings: `Configurações de Segurança`,
    Phone: `Celular:`,
    Password: `Senha:`,
    WithdrawalPassword: `Senha de saque:`,
    AlreadySet: `Já definido`,
    NotConfigured: `Não configurado`,
    EditApelido: {
      Title: 'Configuração de Apelido',
      Subtitle: 'Inserir Novo Apelido',
      Placeholder: 'Por favor, edite o apelido.',
    },
    EditSenha: {
      Title: 'Configuração de Senha',
      OriginalPassword: 'Senha antiga ',
      OriginalPasswordPlaceholder: 'Digite a senha atual',
      NewPassword: 'Nova senha',
      NewPasswordPlaceholder: 'Digite sua nova senha',
      ConfirmPassword: 'Confirmar nova senha',
      ConfirmPasswordPlaceholder: 'Digite a nova senha novamente',
    },
    editVerificado: {
      Title: 'Configuração de Apelido',
      PhoneNumber: 'Número de telefone',
      PhoneNumberPlaceholder: 'Número de telefone',
      Password: 'Senha',
      PasswordPlaceholder: 'Por favor, insira a senha',
      VerificationCode: 'Código de verificação',
      VerificationCodePlaceholder: 'Código de verificação',
    },
  },
  Activities: {
    GiftCode: {
      Title: 'Introduza / Colar o código de resgate do cupom:',
      Placeholder: 'Introduzir / Colar…',
      Paste: 'Colar',
      Exchange: 'Troca',
      PasteTip: '*Pressione e segure para colar.',
      FollowUs: 'Acompanhe nossa mídia e obtenha códigos de resgate:',
      ActivityDesc: 'Descricão da Atividade',
    },
    Vip: {
      LeftText: `Registo de Envio de Bónus`,
      CollectionRegistration: `Registo da Colecção`,
      UpgradePrize: `Prêmio de Upgrade`,
      MonthlyBonus: `Bónus Mensal`,
      WeeklyBonus: `Bónus Semanal`,
      CollectionTime: `Tempo de recolha`,
      Event: `Evento`,
      Money: `Dinheiro`,
      RechargeToLevelUp: `(Apostas {nextLevelBet} para subir de nível）`,
      DepositToLevelUp: `(Depósito R\${nextLevelDeposit} para subir de nível）`,
      CanReceiveBonus: 'Pode receber bónus(R$)',
      BonusHistory: 'Registro de Envio de Bónus',
      ActivityDescription: 'Descricão da Atividade',
      VipLevel: 'Nível VIP',
      AccumulatedBets: 'Apostas Acumuladas',
      AccumulatedDeposit: 'Depósito Acumuladas',
    },
    Agentcenter: {
      ShareLink: 'Compartilhe o link para convidar amigos.',
      MyEarnings: 'Meus Ganhos',
      ViewDetails: 'Ver Detalhes',
      YesterdaySummary: 'Resumo de Ontem',
      MyTeam: 'Meu Time',
      ActivityDescription: 'Descricão da Atividade',
      AgentDetail: {
        Title: 'Descrição Do Agente',
        Filter: 'Filtro',
        SearchPlaceholder: 'Insira o ID do subordinado...',
        RegistrationDate: 'Data de Registro:',
        ProvideIncome: 'Fornecer renda',
        Deposit: 'Depósito',
        Withdrawal: 'Saques',
        Bet: 'Apostas',
        ProfitAndLoss: 'Lucro e prejuízo',
        GiftMoney: 'Dinheiro de presente',
        SubordinateData: 'Dados dos subordinados',
        CommissionIncome: 'Comissão renda',
        Subordinates: 'Novos Registros',
        Registrations: 'Usuários Visitantes',
        FirstDeposit: 'Primeiro depósito',
        SubordinateRecharge: 'Recarregar subordinados',
        SubordinateBets: 'Apostas dos subordinados',
        Gifts: 'Presentes',
        NoDataText:
          'Nenhum registro ainda\nPor favor, entre em contato com o agente para recarregar as moedas e começar o jogo',
        WaitingForQuery: 'Aguardando resultado da consulta',
        FilterConditions: 'Condições de Filtro',
        SelectTime: 'Selecionar Tempo',
        Today: 'Hoje',
        Yesterday: 'Ontem',
        ThisWeek: 'Esta semana',
        ThisMonth: 'Este mês',
        LastMonth: 'Mês passado',
        LastThreeMonths: 'Últimos três meses',
        SuperiorAgent: 'Agente Superior',
        AgentGeneral: 'Agente Gera',
        AgentLevel: 'Nível {level} Agente',
      },
      Agentrule: {
        Title: 'Descrição Do Agente',
        CurrentCommissionSettings:
          'As configurações atuais de comissão de agência são as seguintes:',
        Level1Agent:
          'Agente de nível 1: Proporção de comissão de recarga de {depositRatios}%, comissão de aposta de {betRatios}%',
        Level2Agent:
          'Agente de nível 2: Proporção de comissão de recarga de {depositRatios}%, comissão de aposta de {betRatios}%',
        Level3Agent:
          'Agente de nível 3: Proporção de comissão de recarga de {depositRatios}%, comissão de aposta de {betRatios}%',
        BusinessOpportunity:
          'A foi o primeiro usuário a descobrir a oportunidade de negócio e rapidamente recrutou B1, B2 e B3; B1 por sua vez recrutou C1 e C2; B2 não possui nenhum subagente; B3 recrutou C3; C1 recrutou D1。',
        SecondDayRecruitment:
          'No segundo dia, os seguintes usuários foram recrutados como subagentes:',
        CommissionCalculationRules: 'Regras de cálculo de comissão',
        TotalCommission: 'Comissão total de receita de A',
        DirectAgentCommission: 'Comissão contribuída pelos agentes diretos',
        Level2AgentCommission: 'Comissão contribuída pelos agentes de 2 nível',
        Level3AgentCommission: 'Comissão contribuída pelos agentes de 3 nível',
        CommissionCalculationMethod:
          'A forma de cálculo da comissão de agente é a seguinte :',
        CommissionCalculation: {
          C1Commission: '1.Comissão de C1 ( Fornecida diretamente por D1)',
          B1Commission: '2.Comissão de B1',
          B1DirectCommission:
            'Comissão direta ( Fornecida diretamente por C1, C2 )',
          B1TeamCommission:
            'Comissão de equipe ( Equipe de 2 nível fornecida por D1 )',
          B2Commission: '3.Comissão de B2 ( Sem subagentes )',
          B3Commission: '4.Comissão de B2 ( Fornecida diretamente por C3 )',
          ACommission:
            '5.Comissão de A，Proveniente da equipe de 3 nível subordinada',
          ALevel1Team: 'Fornecido diretamente por B1, B2, B3',
          ALevel2Team: 'Equipe de 2 nível: fornecido por C1, C2, C3',
          ALevel3Team: 'Equipe de 3 nível: fornecido por D1',
          TotalCommission: 'Comissão total de A ( Direta + Equipe)',
        },
      },
      Components: {
        GanhosContent: {
          EstimatedRevenue: 'Receita estimada',
          TeamDeposit: 'Depósito de equipe',
          DepositCommission: 'Comissão de Depósito Recebida ',
          TeamBet: 'Aposta de equipe',
          BetCommission: 'Comissão de Aposta Recebida',
          AvailableCommission: 'Comissão disponível',
          Value: 'Valor',
          Receive: 'Receber',
          ReceivedEarnings: 'Ganhos Recebidos',
        },
        ResumoContent: {
          YesterdayIncome: `Rendimento de Ontem`,
          SubordinatedDeposits: `Depósitos Subordinados`,
          SubordinatesTakeout: `Saque Subordinados`,
          StationedSubordinates: `Apostado Subordinados`,
          SubordinatedProfit: `Lucro Subordinados`,
        },
        TimeContent: {
          AgentLevel: `Nível Agente`,
          Number: `Número`,
          CommissionValue: `Valor Comissão`,
          SuAgentLevel: `Agente Nível`,
        },
      },
      Income: {
        AgentDetails: 'Detalhes do Agente',
        TeamList: 'Lista de times',
        SwipeTable: 'Deslize a tabela',
        DateFilter: 'Filtro de data',
        FilterAgentRange: 'Filtrar intervalo de agente',
        AllAgentEarnings: 'Tudo Agente Ganhos',
        Level1AgentEarnings: 'Nível 1 Agente Ganhos',
        Level2AgentEarnings: 'Nível 2 Agente Ganhos',
        Level3AgentEarnings: 'Nível 3 Agente Ganhos',
        PullToRefresh: 'Deslize para baixo para atualizar',
        ReleaseToRefresh: 'Solte para atualizar',
        Loading: 'Aguardando resultado da consulta',
        Success: 'sucesso',
        Date: 'Data',
        MyEarnings: 'Meus Ganhos',
        SubordinateDeposits: 'Depósitos Subordinados',
        SubordinateWithdrawals: 'Saques Subordinados',
        SubordinateBets: 'Apostas Subordinados',
        SubordinateProfit: 'Lucro Subordinados',
        AgentId: 'ID Agente',
        AgentLevel: 'Nível Agente',
        ParentId: 'ID Superior',
        ContributionAmount: 'Valor Contribuição',
      },
    },
    Bonus: {
      CanBeCollected: 'Pode Ser Coletado',
      History: 'Histórico',
      NextEventCountdown: 'Contagem Para O Próximo Evento',
      Days: 'dias',
      Hours: 'h',
      Minutes: 'min',
      Seconds: 's',
      CurrentPrizeProgress: 'Progresso dos Prêmios Atuais',
      MakeDeposit: 'Fazer Depósito',
      ActivityDescription: 'Descricão da Atividade',
      Bonus: `Bônus`,
      ScratchCards: `Raspadinhas`,
      ticket: `bilhete`,
      BonusRange: `Faixa de prêmio do bilhete de raspadinha: R$ 10,00 - R$ 15,00`,
      Period: `Período`,
      ToReceive: `Receber`,
      Rescued: `Resgatado`,
      Expired: `Expirado`,
      Deposit: 'Depósito',
      Award: 'Prêmio',
      DepositType: {
        First: 'Primeiro',
        Single: 'Cada',
        Accumulate: 'Acumulado',
      },
      Prize: {
        Value: 'Valor：',
        Maximum: 'Maior:',
        Progress: 'Progresso',
      },
      HistoryTabs: {
        Available: `Disponível`,
        resgated: `Resgatado`,
        expired: `Expirado`,
        InvalidActivityId: 'Invalid activityId',
      },
    },
    Jiujijin: {
      CompensationPeriod: 'Compensação deste período：',
      ProfitPeriod: 'Lucro deste período：',
      CompensationDistributed: 'A compensação deste período será distribuída',
      AvailableCompensation: 'Compensação disponível',
      Receive: 'Receber',
      DailyProfit: 'Lucro diário',
      Compensation: 'Compensação',
      ActivityDescription: 'Descricão da Atividade',
      The: `Das`,
      To: `às`,
    },
    Rebate: {
      History: 'Histórico',
      DepositAndParticipate: 'Deposite e participe da atividade',
      CurrentDeposit: 'Depósito Atual',
      Deposit: 'Depósito',
      RebateRate: 'Taxa de reembolso',
      ReceivingMaxRebate: 'Recebendo a Taxa Máxima de Reembolso',
      Bet: 'Aposte',
      ToReceive: 'para receber',
      ValidBets: 'Apostas Válidas',
      Collectable: 'Coletável',
      ActivityDescription: 'Descrição da Atividade',
      Receive: 'Receber',
      WinningTips: `Parabéns por ganhar`,
      BonusChips: `em fichas de bônus`,
      Detail: {
        LeftText: `Regras de Rebate`,
        GamesExcludedFromRebate: `Jogos Excluídos do Rebate`,
        FilterConditions: `Condições de Filtro`,
        FilterCames: `Filtrar jogos`,
        ValidBets: `Apostas Válidas`,
        RebateRate: `Taxa de Rebate`,
      },
      Historial: {
        Title: 'Histórico',
        Bonus: 'Bonus',
        FilterConditions: 'Condições de Filtro',
        SelectTime: 'Selecionar Tempo',
        Time: 'Tempo',
        Event: 'Evento',
        BonusAmount: 'Bonus',
        Today: 'Hoje',
        Yesterday: 'Ontem',
        Last7Days: 'Últimos 7 Dias',
        Last15Days: 'Últimos 15 Dias',
        Last30Days: 'Últimos 30 Dias',
      },
      RewardTitle: 'Não Esqueça!',
      RewardContent:
        'Quanto mais apostar hoje, maior o cashback amanhã! Você já está qualificado — continue jogando e volte amanhã às 00h para resgatar!',
      NoShowAgain: 'Não mostrar novamente hoje',
    },
    Redpackage: {
      PerTimeShowMaxAmount: 'por vez',
      MaxRemaining: 'Máx queda',
      OpeningHours: 'Horário de Abertura',
      ActivityDescription: 'Descricão da Atividade',
      FailedToRedeem: 'Falha ao receber',
      SorryNotEligible:
        'Desculpe, você não atende às condições para participar do evento',
      SorryLimitReached: 'Desculpe, você atingiu o limite de resgates de hoje',
      OpeningSoon: 'Abrirá em Breve',
      Mined: 'Minerado',
      TodaysEarnings: 'Ganhos de hoje',
      CollectionTime: 'Horário de coleta',
      NotEigible:
        'Desculpe, você não atende às condições para participar do evento.',
      ExchangeLimit: 'Desculpe, você atingiu o limite de resgates de hoje.',
      UserEffectiveConditions: 'Condições efetivas do utilizador',
      MeetAllConditions: 'Atender a todas as condições',
      MeetAnyCondition: 'Atender a qualquer condição',
      Deposits: 'Depósitos',
      DepositAction: 'Depósito >',
      Bet: 'Aposta',
      BetAction: 'Aposta >',
      FirstDeposit: 'Primeira\nDepósito',
      WinnersAnnouncement: 'Anúncio dos Vencedores',
      UserReceivedReward:
        'O usuário {username} recebeu uma recompensa em dinheiro de',
    },
    SecretBonus: {
      RegistrationTime: 'Hora de Início :',
      ExclusiveEvent: 'Evento exclusivo para novos usuários',
      DepositeToActivateEvent: 'Deposite para ativar o evento',
      MysteryBonus: 'Bónus Misterioso:',
      Maximum: 'Maior:',
      DepositTotal: 'Depósito total de {days} dia(s):',
      ToReceive: 'Receber',
      Deposit: 'Depósito',
      ActivityDescription: 'Descricão da Atividade',
      BonusExpired: 'O bônus expirou',
      UserReceivedReward: 'Já recebeu',
      CanClaimAfter: 'Pode reivindicar o prêmio após {days} dia(s)',
      NotAvailableForCollection: 'Não pode ser retirado',
      Prize: 'Prêmio',
    },
    treasurebox: {
      InviteLink: 'Link de Convite',
      QuickShare: 'Compartilhamento Rápido',
      UserEffectiveConditions: 'Condições efetivas do utilizador',
      AccumulatedDeposits: 'Depósitos acumulados',
      GameBets: 'Apostas no jogo',
      Subordinate: 'Subordenada',
      Effective: 'Eficaz',
      Name: 'Nome',
      Deposit: 'Depósito',
      Bets: 'Apostas',
      LinkDeConvite: 'Link de Convite',
      CompartilhamentoRapido: 'Compartilhamento Rápido',
      MeusSubordinadosDiretos: 'Meus subordinados diretos',
      Pessoas: 'Pessoa',
      Expirado: 'Expirado',
      RecompensaResgatadaComSucesso: 'Recompensa resgatada com sucesso',
      DescricaoDaAtividade: 'Descricão da Atividade',
    },
  },
  BindPhone: {
    LeftText: `Número verificado`,
    PhoneNumber: 'Número de telefone',
    Password: 'Senha',
    VerificationCode: 'Código de verificação',
    BindPhone: 'Vincular celular',
  },
  ChooseSaque: {
    LeftText: `Saque`,
    ChooseWithdrawalChannel: 'Escolha o canal de saque:',
    AfterSuccessfulPayment:
      'Após o pagamento bem-sucedido, o saldo do jogo é atualizado em até 3 minutos. Se o pagamento falhar, por favor escolha outro canal de pagamento.',
  },
  Saque: {
    EnterAmount: {
      MyBalance: `Meu Saldo:`,
      WithdrawalRestrictions: `Saque requer um volume de jogo de {limitAmount}`,
    },
    EnterMessage: {
      WithdrawalAmount: 'Valor do saque',
      TaxIDType: 'Tipo de ID Fiscal',
      ID: 'ID',
      BeneficiaryName: 'Nome do Beneficiário',
      AccurateContactInformation:
        'Por favor, forneça informações de contato precisas para garantir o processamento bem-sucedido do seu saque.',
      EnterYourCPFTips: 'Por favor, insira o CPF ID',
      CPFRulesTips: 'Por favor insira 11 dígitos para CPF',
      EnterYourEmailTips: 'Por favor, insira o Email ID',
      EmailRulesTips:
        'Por favor insira um endereço de e-mail com até 36 caracteres',
      EnterYourPhoneTips: 'Por favor, insira o PHONE ID',
      PhoneRulesTips:
        'Por favor, insira 10 ou 11 dígitos sem o +55 para o seu número de celular.',
      EnterYourCNPJTips: 'Por favor, insira o CNPJ ID',
      CNPJRulesTips: 'Por favor insira o número puro de 14 dígitos CNPJ',
      EnterYourEVPTips: 'Por favor, insira o EVP ID',
      EVPRulesTips: 'Por favor insira 36 dígitos para EVP',
      PleaseProvide: `Por favor, informe o nome do`,
      EnterYourCPF: `Por favor, digite o CPF`,
    },
    SaqueSuccess: {
      OrderNumber: `Número do pedido`,
      WithdrawalRequestSent: `Solicitação de saque enviada`,
      WithdrawalRequestFailed: `Solicitação de saque falhou`,
      WithdrawalSuccessMessage: `O valor será creditado automaticamente em aproximadamente 1 a 10 minutos.`,
      WithdrawalFailedMessage: `Por favor, verifique se as informações do saque estão corretas ou entre em contato com o suporte ao cliente.`,
      CustomerService: `suporte ao cliente>`,
      BackToHome: `Voltar para a página inicial`,
    },
    SendPassword: {
      CheckWithdrawalPassword: `Verificar senha de saque`,
      PasswordErrorMessage: ` A senha de saque está incorreta, por favor, tente novamente.`,
    },
  },
  SaquePw: {
    LeftText: `Configuração de senha de saque`,
    LoginPw: `Senha de Login`,
    NewWithdrawalPw: `Novo Saque Senha`,
    ConfirmWithdrawalPw: `Confirmar Saque Senha`,
    PwMismatchPrompt: `ConAs senhas inseridas não coincidem`,
    ConfiguredSuccessfully: `Configurado com sucesso`,
    PwoSsettingSuccessfulTips: `nova senha definida com sucesso, lembre-se de sua senha`,
    ReturnToHome: `Retornar à página inicial`,
    ContinueWithTheWithdrawal: `Continuar com o saque`,
  },
  Message: {
    leftText: `Central de Mensagens`,
    SystemMessage: 'Mensagem do Sistema',
    NoMessages: 'Sem mensagens',
    CleanMessageTips: `Deseja apagar todos os registros de mensagens?`,
  },
  Common: {
    Cancel: 'Cancelar',
    Confirm: 'Confirme',
    Loading: `Carregando...`,
    More: `Mais`,
    more: `mais`,
    Success: 'Sucesso',
    Fail: 'Falha',
    AlreadyLogin: 'Já está logado',
    UpdateReloadTitle: 'Nova versão disponível!',
    UpdateReloadContent:
      'Clique em “Atualizar” para usar a nova versão. Mais rápida, estável e sem precisar baixar nada!',
    UpdateReloadConfirm: 'Atualizar agora',
  },
  Template: {
    store: {
      defaultDeveloper: 'Emp. de Desenv. de Jogos de Slots',
      app: 'Compras no app',
      reviews: 'avaliações',
      downloads: 'downloads',
      rated: 'Todos',
      play: 'Jogar',
      install: 'Instalar',
      installing: 'Instalando',
      share: 'Compartilhar',
      wishlist: 'Adicionar à lista de desejos',
      about: 'Sobre este app',
      updated: 'Atualizado em',
      data: 'Segurança dos dados',
      safety: 'Segurança',
      parties: 'Parties',
      types: 'Tipos',
      sharing: 'Compartilhamento',
      location: 'Localização',
      transit: 'Transição',
      request: 'Solicitação',
      details: 'Mais detalhes',
      ratings: 'Classificações e resenhas',
      phone: 'Telefone',
      tablet: 'Tablet',
      verified: 'As notas e avaliações são verificadas',
      avaliações: 'avaliações',
      aútilpor: 'Essa avaliação foi marcada como útil por',
      pessoas: 'pessoas',
      Sim: 'Sim',
      Não: 'Não',
      Cassino: 'Cassino',
      níqueis: 'Caça-níqueis',
      Vocêachou: 'Você achou isso útil?',
      Games: 'Jogos',
      Movies: 'Filmes e TV',
      Books: 'Livros',
      Kids: 'Crianças',
      impróprio: 'Sinalizar como impróprio',
      todasavaliações: 'Ver todas as avaliações',
      denovo: 'O que há de novo',
    },
    video: {},
  },
  InitDialog: {
    title: 'Inicialização falhou',
    message: 'A inicialização falhou, tente novamente mais tarde',
    confirmButtonText: 'Atualizar',
  },
  BonusDoublePopupTips: {
    claimSuccessTip: 'Recebido com sucesso',
    claimFailedTip: 'Falha ao receber',
  },
  PhoneCodeInput: {
    alreadySend: 'O código de verificação por SMS foi enviado.',
    tips: 'Não pode ser vazio',
    placeholder: 'Insira o código SMS',
  },
  CpfInput: {
    placeholder: 'Por favor, insira o CPF',
    tips: 'CPF inválido',
  },
}
